import { render, staticRenderFns } from "./xhome.vue?vue&type=template&id=d701c80e&scoped=true&"
import script from "./xhome.vue?vue&type=script&lang=js&"
export * from "./xhome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d701c80e",
  null
  
)

export default component.exports